module.exports = __webpack_public_path__ + "static/media/fb-feed.35de5b80.svg";